import React from 'react';
import { API_ENDPOINTS } from '../../config';

const StatusCheck = ({ data }) => {
  // Default config if no data provided
  const config = data || {
    sectionTitle: "Check Your Application Status",
    sectionDescription: "Enter your email or reference number to track your application",
    inputPlaceholder: "Email or Reference Number",
    buttonText: "Check Status",
    statusColors: {
      SUBMITTED: 'blue',
      UNDER_REVIEW: 'yellow',
      APPROVED: 'green',
      REJECTED: 'red'
    }
  };

  const checkStatus = async () => {
    const input = document.getElementById('statusInput').value;
    const resultDiv = document.getElementById('statusResult');
    
    if (!input) {
      resultDiv.className = 'mt-6 p-4 rounded-xl bg-red-50 border border-red-200 text-left';
      resultDiv.innerHTML = '<strong class="text-red-600">Error:</strong> Please enter your email or reference number';
      return;
    }

    // Show loading state
    resultDiv.className = 'mt-6 p-4 rounded-xl bg-blue-50 border border-blue-200 text-left';
    resultDiv.innerHTML = '<div class="text-blue-600">Checking status...</div>';

    try {
      const response = await fetch(`${API_ENDPOINTS.applications.status}/${input}`);
      const result = await response.json();

      if (response.ok && result.success) {
        const color = config.statusColors[result.data.status] || 'gray';
        
        resultDiv.className = `mt-6 p-4 rounded-xl bg-${color}-50 border border-${color}-200 text-left`;
        resultDiv.innerHTML = `
          <div class="mb-2">
            <strong>Status:</strong> 
            <span class="inline-block px-3 py-1 rounded-full text-sm font-semibold bg-${color}-100 text-${color}-700 ml-2">
              ${result.data.status}
            </span>
          </div>
          <div class="text-sm text-slate-600 space-y-1">
            <div><strong>Reference:</strong> ${result.data.referenceNumber}</div>
            <div><strong>Submitted:</strong> ${new Date(result.data.submittedAt).toLocaleDateString()}</div>
          </div>
        `;
      } else {
        resultDiv.className = 'mt-6 p-4 rounded-xl bg-red-50 border border-red-200 text-left';
        resultDiv.innerHTML = `<strong class="text-red-600">Not Found:</strong> ${result.message || 'Application not found'}`;
      }
    } catch (error) {
      resultDiv.className = 'mt-6 p-4 rounded-xl bg-red-50 border border-red-200 text-left';
      resultDiv.innerHTML = '<strong class="text-red-600">Error:</strong> Failed to check status. Please try again.';
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      checkStatus();
    }
  };

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          {/* Section Header */}
          <h2 className="text-2xl font-bold mb-4">{config.sectionTitle}</h2>
          <p className="text-slate-600 mb-6">{config.sectionDescription}</p>
          
          {/* Status Check Input */}
          <div className="flex gap-3 max-w-md mx-auto">
            <input 
              type="text" 
              id="statusInput" 
              placeholder={config.inputPlaceholder}
              onKeyPress={handleKeyPress}
              className="flex-1 p-3 border-2 border-slate-200 rounded-lg focus:border-blue-600 focus:outline-none"
            />
            <button 
              onClick={checkStatus}
              className="px-6 py-3 rounded-xl text-white font-semibold bg-gradient-to-r from-blue-600 to-purple-600 shadow hover:shadow-lg transition-all"
            >
              {config.buttonText}
            </button>
          </div>

          {/* Result Container */}
          <div id="statusResult" className="mt-6"></div>

          {/* Help Text */}
          {config.helpText && (
            <p className="mt-4 text-sm text-slate-500">{config.helpText}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default StatusCheck;